import * as ACTIONS from '../actionTypes';
import CountryData from '../../Lib/Countries.json';
import { getCurrentCompanyId } from '../../Lib/Utils';
import { postAPI } from '../api';

export function setMenuName(name) {
    return async (dispatch) => {
        dispatch({
            type: ACTIONS.SET_MENU_NAME,
            payload: name,
        });
    };
}
export function searchKey(value) {
    return async (dispatch) => {
        dispatch({
            type: ACTIONS.SEARCH_KEY,
            payload: value,
        });
    };
}

export function loading(flag) {
    return async (dispatch) => {
        if (flag) {
            dispatch({
                type: ACTIONS.LOADING_ON,
            });
        } else {
            dispatch({
                type: ACTIONS.LOADING_OFF,
            });
        }
    };
}

export function getStates() {
    return async (dispatch) => {
        const data = {};
        CountryData.countries.forEach((item) => {
            data[item.country] = item.states;
        });

        dispatch({
            type: ACTIONS.LOADING_ALL_STATES,
            payload: data,
        });
    };
}

export function getS3File(params) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            try {
                params.CompanyId = getCurrentCompanyId();
                const res = await postAPI('/uploads', params);
                return resolve(res);
            } catch (err) {
                return reject(err);
            }
        });
    };
}
